import { inject } from "@angular/core";
import { RedirectCommand, ResolveFn, Router } from "@angular/router";
import { StudentProgramTaskResult } from "projects/shared/src/lib/core/models/userProgramTaskResult.model";
import { UserProgramService } from "projects/shared/src/lib/core/services/user-program.service";
import { ExerciseStore } from "projects/shared/src/lib/store/exercise.store";
import { catchError, from, map, of } from "rxjs";

export const taskResultResolver: ResolveFn<StudentProgramTaskResult | RedirectCommand> = () => {
    const userProgramService = inject(UserProgramService);
    const exerciseStore = inject(ExerciseStore);
    const router = inject(Router);

    const taskResultId = exerciseStore.activeTask()?.taskResultId ?? 0;
    if (!taskResultId) {
        return of(new RedirectCommand(router.parseUrl('/')));
    }
    return from(userProgramService.getUserProgramTaskResult(taskResultId)).pipe(
        map(result => result),
        catchError(error => {
            console.error('Failed to load task result:', error);
            return of(new RedirectCommand(router.parseUrl('/')));
        })
    );
  };